<template>
  <div class="bindMobile">
    <div class="header">
      <div class="common_content clearfix">
        <div class="header_left">{{ title }}</div>
        <div class="header_right">
          <router-link to="/">
            <el-link :underline="false" style="padding:0px 10px;">返回首页</el-link>
          </router-link>
        </div>
      </div>
    </div>
    <div class="common_content">
      <img src="/image/index/logo.png" alt style="padding:30px 0px 30px 0px"/>
    </div>
    <div class="backgrond common_backgroundImg" style="height:470px">
      <el-card class="box-card">
        <div class="signin_title">
          <h2>绑定手机号</h2>
        </div>
        <div class="signin_form">
          <el-form
              :model="bindForm"
              status-icon
              :rules="bindRules"
              ref="bindForm"
              label-width="85px"
              class="demo-ruleForm"
          >
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="bindForm.mobile" placeholder="请输入您手机号" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input
                  v-model="bindForm.code"
                  placeholder="短信验证码"
                  autocomplete="off"
                  maxlength="4"
              >
                <el-button
                    slot="append"
                    @click="getCode('bindForm')"
                    class="verificationCode"
                    :disabled="timeLoading"
                    style="color: #67c23a"
                >{{ !timeLoading ? '获取验证码' : checkTime + 'S重新获取' }}
                </el-button>
              </el-input>
            </el-form-item>
            <div style="text-align: center;margin:15px 0px 0px 0px">
              <el-button type="danger" style="width:150px;height:40px" @click="bind('bindForm')">绑 定</el-button>
            </div>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="foot">
      <foot :content="this.$route.meta.bottomFlag"/>
    </div>
  </div>
</template>
<script>
import foot from "@/views/admin/components/foot.vue";
import {isMobile} from "@/util/validate.js";
import {getStore} from "@/util/store";
import {GetMessageCode, MobileVerify} from "@/api/admin/login.js";

var checkmobile = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入联系方式"));
  } else {
    if (isMobile(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的电话"));
    }
  }
};
var checkCode = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入验证码"));
  } else {
    if (String(value).length == 4) {
      callback();
    } else {
      return callback(new Error("请输入四位数验证码"));
    }
  }
};
export default {
  components: {
    foot
  },
  data() {
    return {
      title: "欢迎来到羽毛球运动水平等级评定!",
      bindForm: {
        mobile: "",
        code: ""
      },
      bindRules: {
        code: [{validator: checkCode, trigger: "blur"}],
        mobile: [{validator: checkmobile, trigger: "blur"}]
      },
      checkTime: "",
      timeLoading: false,
      timer: null
    };
  },
  created() {
  },
  methods: {
    getCode(bindForm) {
      this.$refs[bindForm].validateField("mobile", errMsg => {
        if (!errMsg) {
          GetMessageCode({mobile: this.bindForm.mobile}).then(data => {
            const list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.$message({
                  message:
                      "验证码已成功发送至“ " +
                      this.bindForm.mobile +
                      " ”请您注意查收",
                  type: "success",
                  duration: "5000"
                });
                if (!this.timer) {
                  this.checkTime = 120;
                  this.timeLoading = true;
                  this.timer = setInterval(() => {
                    if (this.checkTime > 0 && this.checkTime <= 120) {
                      this.checkTime--;
                    } else {
                      clearInterval(this.timer);
                      this.timeLoading = false;
                      this.timer = null;
                    }
                  }, 1000);
                }
              } else {
                this.$message.error("验证码发送失败，请重新获取");
              }
            }
          });
        }
      });
    },
    bind(bindForm) {
      var userInfo = getStore({name: "userInfo"});
      this.bindForm.userId = userInfo.userId;
      this.$refs[bindForm].validate(valid => {
        if (valid) {
          this.bindForm.flag = true
          MobileVerify(this.bindForm).then(data => {
            if (data.data.result) {
              if (data.data.result.isSuccess) {
                this.$message({
                  message: "绑定手机成功，请重新登录",
                  type: "success"
                });
                this.$router.push({path: "/signin"});
              } else {
                this.$message({
                  message: data.data.result.errorMsg,
                  type: "warning"
                });
              }
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less">
.bindMobile {
  .header {
    /* Rectangle 137 */
    width: 100%;
    height: 42px;
    line-height: 42px;
    left: 0px;
    top: 0px;
    background: rgba(244, 244, 244, 0.85);

    .header_left {
      font-family: Source Han Sans CN;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #000000;
      float: left;
    }

    .header_right {
      float: right;
    }
  }

  .backgrond {
    /* 背景1 4 */
    width: 100%;
    // height: 580px;
    background-image: url(/image/index/yumaoqiu3344.png);
    position: relative;

    .box-card {
      width: 35%;
      position: absolute;
      top: 15%;
      right: 7%;

      .signin_title {
        text-align: center;

        h2 {
          display: inline-block;
          border-bottom: 2px solid #ea0000;
          border-radius: 2px;
          padding: 10px;
        }
      }

      .signin_form {
        padding: 30px 30px;

        .signin_radio_partient {
          .el-form-item__content {
            margin-left: 0px !important;
          }
        }

        .signin_radio {
          display: flex;
          justify-content: space-around;
          margin: 30px 0px 0px 0px;
        }

        .verificationCode {
          font-size: 12px;
          width: 110px;
          color: #67c23a;
        }

        .refor {
          display: flex;
          justify-content: space-between;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      .box-card {
        position: absolute;
        width: 60% !important;
        right: 0px;
        left: 0px;
        margin: 0 auto;
      }
    }
    @media screen and (max-width: 767px) {
      .box-card {
        width: 90% !important;

        .el-card__body {
          padding: 20px 10px;

          .signin_title {
            h2 {
              font-size: 18px;
            }
          }

          .signin_form {
            padding: 10px 4px;

            .verificationCode {
              width: 90px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}


</style>
